// extracted by mini-css-extract-plugin
module.exports = {"modal":"NotificationRulesModal_modal__1M8p7"};